import React, { useEffect, useState } from 'react';
import { useTournament } from '../TournamentContext';
import axios from 'axios';
import config from "../../config/default.json";


const base_url = config.base_url;

const ManageCustomPlayoff = () => {
  const { tournamentID } = useTournament();
  const [teams, setTeams] = useState([]);
  const [playoffgames, setPlayOffGames] = useState([]);
  const [gameScores, setGameScores] = useState({});
  const [selectedTeams, setSelectedTeams] = useState({});
  const token = localStorage.getItem("token");


  useEffect(() => {
    if (tournamentID) {
      fetchTeams();
      fetchPlayoffGames();
    }
  }, [tournamentID]);

  const fetchTeams = async () => {
    try {
      const url = `${base_url}/api/teams/${tournamentID}`;
      const response = await axios.get(url);
      setTeams(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchPlayoffGames = async () => {
    try {
      const url = `${base_url}/api/playoffgames/all/${tournamentID}`;
      const response = await axios.get(url);
      setPlayOffGames(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleScoreChange = (e, gameId, team) => {
    const { value } = e.target;
    setGameScores((prev) => ({
      ...prev,
      [gameId]: {
        ...prev[gameId],
        [`scoreTeam${team}`]: value,
      },
    }));
  };

  const handleCourtChange = (e, gameId) => {
    const { value } = e.target;
    setGameScores((prev) => ({
      ...prev,
      [gameId]: {
        ...prev[gameId],
        court: value,
      },
    }));
  };

  const handleTeamSelect = (gameId, teamNumber, teamId) => {
    setSelectedTeams((prev) => ({
      ...prev,
      [gameId]: {
        ...prev[gameId],
        [`team${teamNumber}`]: teamId,
      },
    }));
  };

  const updateAllPlayoffGame = async () => {
    try {
      await Promise.all(
        playoffgames.map(async (game) => {
          const updates = {};
          const scoreUpdates = gameScores[game._id] || {};
          const teamUpdates = selectedTeams[game._id] || {};

          if (scoreUpdates.scoreTeam1 !== undefined) {
            updates.scoreTeam1 = scoreUpdates.scoreTeam1;
          }
          if (scoreUpdates.scoreTeam2 !== undefined) {
            updates.scoreTeam2 = scoreUpdates.scoreTeam2;
          }
          if (scoreUpdates.court !== undefined) {
            updates.court = scoreUpdates.court;
          }
          if (teamUpdates.team1 !== undefined) {
            updates.team1 = teamUpdates.team1;
          }
          if (teamUpdates.team2 !== undefined) {
            updates.team2 = teamUpdates.team2;
          }

          if (Object.keys(updates).length > 0) {
            await axios.put(`${base_url}/api/${tournamentID}/playoffgames/${game._id}`, updates, { headers: { Authorization: `Bearer ${token}` }});
          }
        })
      );

      fetchPlayoffGames();
      setGameScores({});
      setSelectedTeams({});
      alert('Playoff Games updated successfully!');
    } catch (error) {
      console.error('Failed to update Playoff game', error);
    }
  };

  const createPlayoffGames = async () => {
    try {
      await axios.delete(`${base_url}/api/playoffgames/${tournamentID}`);

      const roundrank = [
        [1, 1], [1, 2], [1, 3], [1, 4],
        [1, 5], [1, 6], [1, 7], [1, 8],
        [2, 1], [2, 2], [2, 3], [2, 4],
        [3, 1], [3, 2], [4, 1]
      ];

      for (const [round, rank] of roundrank) {
        await axios.post(`${base_url}/api/playoffgames/${tournamentID}`, {
          round,
          rank,
        });
      }

      fetchPlayoffGames();
      alert('Playoff Games added successfully!');
    } catch (error) {
      console.error('Failed to create games', error);
    }
  };

  return (
    <div>
      <br />
      <p>This button will create playoff games.</p>
      <button onClick={createPlayoffGames}>Create Playoff Games</button>
      <br /><br /><br />
      <h2>Playoff Score & Court Update</h2>

      <table className="schedule-table">
        <thead>
          <tr>
            <th>Team 1</th>
            <th>Team 2</th>
            <th>Team 1 Score</th>
            <th>Team 2 Score</th>
            <th>Court</th>
            <th>Round</th>
            <th>Rank</th>
            <th>Update Court</th>
            <th>Update Team 1 Score</th>
            <th>Update Team 2 Score</th>
          </tr>
        </thead>
        <tbody>
          {playoffgames
            .filter((game) => game.isWildCard === false)
            .map((game) => (
              <tr key={game._id}>
                <td>
                  <select
                    value={selectedTeams[game._id]?.team1 || game.team1?._id || ''}
                    onChange={(e) => handleTeamSelect(game._id, 1, e.target.value)}
                  >
                    <option value="">-- Select Team 1 --</option>
                    {teams.map((team) => (
                      <option key={team._id} value={team._id}>{team.name}</option>
                    ))}
                  </select>
                </td>
                <td>
                  <select
                    value={selectedTeams[game._id]?.team2 || game.team2?._id || ''}
                    onChange={(e) => handleTeamSelect(game._id, 2, e.target.value)}
                  >
                    <option value="">-- Select Team 2 --</option>
                    {teams.map((team) => (
                      <option key={team._id} value={team._id}>{team.name}</option>
                    ))}
                  </select>
                </td>
                <td>{game.scoreTeam1}</td>
                <td>{game.scoreTeam2}</td>
                <td>{game.court}</td>
                <td>{game.round}</td>
                <td>{game.rank}</td>
                <td>
                  <input
                    type="number"
                    value={gameScores[game._id]?.court || ''}
                    onChange={(e) => handleCourtChange(e, game._id)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={gameScores[game._id]?.scoreTeam1 || ''}
                    onChange={(e) => handleScoreChange(e, game._id, 1)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={gameScores[game._id]?.scoreTeam2 || ''}
                    onChange={(e) => handleScoreChange(e, game._id, 2)}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      <div>
        <button onClick={updateAllPlayoffGame}>Update Playoff Game</button>
      </div>
    </div>
  );
};

export default ManageCustomPlayoff;
